import React, { Component } from 'react'

import BackgroundCanvas from './BackgroundCanvas'
import SocialMedia from './SocialMedia'

import './App.scss'

export default class App extends Component {
  componentWillMount() {
    this.props.actions.ping()
  }

  render() {
    const { content, title } = this.props

    return (
      <div className="la-tapera-invisible__main-container">
        <BackgroundCanvas />
        <SocialMedia />
        <section className="content">
          <h1>{title}</h1>
          <p>{content}</p>
        </section>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/